module.exports = __webpack_public_path__ + "static/img/img_title_04.7cbed64.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_04.png
// module id = 557
// module chunks = 1